
export class FileShareDiscoveryRangeRequestModel {
  beginIp: string;
  endIp: string;
  interval: string;
}
